import React from "react";

class PopMask extends React.Component {
  maskClick() {
    if (this.props.maskClick) {
      this.props.maskClick();
    }
  }

  render() {
    const { show } = this.props;
    return (
      <div
        className="pop-mask"
        onClick={this.maskClick.bind(this)}
        style={show ? { display: "" } : { display: "none" }}
      />
    );
  }
}

export default PopMask;
